(function () {
    'use strict';

    angular.module('imnApp').controller('OltUploadTftpController', OltUploadTftpController);

    OltUploadTftpController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId'];

    function OltUploadTftpController($scope, $uibModalInstance, OltService, OltData, oltId) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.uploadFileName = uploadFileName;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function uploadFileName() {
            if (vm.formUploadTftp.$valid && !vm.requestRunning) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    fileName: vm.modelUpload.fileName
                };

                OltService.uploadTftpFileToOlt(data).then(successUpload).catch(errorUpload);
            } else {
                errorUpload({status: 400, config: {}});
            }
        }

        function successUpload(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('loadFiles');
        }

        function errorUpload(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelUpload = {
                oltId: 0,
                oltName: '',
                fileName: ''
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelUpload = {
                oltId: data.oltId,
                oltName: data.oltName
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }
        
    }
})();